import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'amountWithCurrency'
})
export class AmountWithCurrencyPipe implements PipeTransform {
  transform(
    value: number | undefined | null,
    currency: string | undefined | null
  ): string {
    if ((value || value === 0) && currency) {
      return value.toFixed(2) + ' ' + currency;
    }
    return '-';
  }
}
